import { render, staticRenderFns } from "./ddScanLogin.vue?vue&type=template&id=70048600&"
import script from "./ddScanLogin.vue?vue&type=script&lang=js&"
export * from "./ddScanLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports